<template>
    <div>
        <div class="row">
            <h1 class="page-title page-title--category">Master Invoices</h1>
        </div>

        <div class="row master-invoices-filter filter sales-filter">
            <form method="get">
                <div class="group-filter">
                    <div
                        class="form-field form-field__select form-field--search"
                    >
                        <label for="agency">Agency</label>
                        <input
                            type="text"
                            v-model="searchRequest"
                            @input="search"
                            id="agency"
                        />
                    </div>
                    <div class="checkbox">
                        <div
                            class="form-field checkbox-wrap"
                            v-for="filter in statuses"
                            :key="filter.id"
                        >
                            <input
                                type="checkbox"
                                :id="`filter_status_${filter.id}`"
                                :value="filter.id"
                                @change="checkboxValue"
                                name="status[]"
                                :ref="`filter_${filter.name.toLowerCase()}`"
                            />
                            <label :for="`filter_status_${filter.id}`"
                                ><i class="icon icon-checkmark"></i
                            ></label>
                            {{ filter.name }}
                        </div>
                    </div>
                </div>

                <div class="form-sales-column">
                    <div
                        class="form-field form-field__select form-field__select--master-invoices"
                    >
                        <label for="period">Sale Period</label>
                        <select
                            name="period"
                            id="period"
                            @change="setValue"
                            class="js-select-custom"
                        >
                            <option value="">All</option>
                            <option
                                v-for="period in periods"
                                :key="period"
                                :value="period"
                                v-text="formatDatePeriod(period)"
                            />
                        </select>
                    </div>
                    <button
                        @click="openColumnsModal"
                        type="button"
                        class="btn btn--gray"
                    >
                        Edit column view
                    </button>
                </div>
            </form>
        </div>

        <div
            class="row master-invoices-pagination master-invoices-pagination--top"
        ></div>

        <div class="row master-invoices-table">
            <div class="table-wrap">
                <table class="table">
                    <thead>
                        <tr
                            v-if="current_columns && current_columns.length > 0"
                        >
                            <th
                                v-for="col_obj in current_columns
                                    .filter((c) => c.status === 'show')
                                    .sort((a, b) => a.position - b.position)"
                                v-bind:key="'col_table_th_' + col_obj.id"
                                @click="sortData(col_obj.slug)"
                            >
                                <span
                                    v-if="lastSort == col_obj.slug"
                                    :class="
                                        descending &&
                                        lastSort == col_obj.slug &&
                                        'sort-icon--desc'
                                    "
                                    ><i class="icon icon-down-arrow"></i
                                ></span>
                                {{ col_obj.name }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="9">
                                <clip-loader
                                    :loading="loading"
                                    :color="'#ec4657'"
                                    :size="'45px'"
                                ></clip-loader>
                            </td>
                        </tr>
                        <tr v-else-if="!items.length && !loading">
                            <td colspan="9"><center>No data</center></td>
                        </tr>
                        <tr
                            v-else-if="
                                searchRequest.length >= 3 && filterItems.length
                            "
                            v-for="item in filterItems"
                            :key="item.id"
                        >
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link && item[_col.slug].link"
                                    :href="item[_col.slug].link"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="deletePartner(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{ item[_col.slug] || "-" }}
                                </p>
                            </td>
                        </tr>
                        <tr
                            v-else-if="
                                !filterItems.length && searchRequest.length >= 3
                            "
                        >
                            <td colspan="16"><center>No data</center></td>
                        </tr>
                        <tr v-else v-for="item in items" :key="item.id">
                            <td
                                v-for="_col in current_columns.filter(
                                    (c) => c.status === 'show'
                                )"
                                v-bind:key="'col_table_partner_' + _col.id"
                            >
                                <a
                                    v-if="_col.is_link && item[_col.slug].link"
                                    :href="item[_col.slug].link"
                                    :style="
                                        item.status == 'Overdue'
                                            ? 'color:red'
                                            : ''
                                    "
                                    >{{ item[_col.slug].name }}</a
                                >
                                <button
                                    v-else-if="_col.slug === 'action'"
                                    class="btn btn--icon"
                                    @click="deletePartner(item.id)"
                                    type="button"
                                >
                                    <i class="icon icon-trash"></i>
                                </button>
                                <p
                                    v-else
                                    :class="
                                        !item[_col.slug] ||
                                        item[_col.slug] === '-' ||
                                        item[_col.slug] <= 0
                                            ? 'color-of-null'
                                            : ''
                                    "
                                >
                                    {{ item[_col.slug] || "-" }}
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row master-invoices-pagination jus-c--right"></div>

        <Column_Modal
            :is_show="showModalColumns"
            :__columns="current_columns"
            :selectColumn="selectColumn"
            :closeModal="closeModal"
            :selected_col="selected_col"
            v-if="showModalColumns"
        ></Column_Modal>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import axios from "axios";
import * as sortArray from "../../parts/sort-array";
import Column_Modal from "../ColumnsModal/index.vue";

export default {
    name: "Master_Invoices",
    props: ["agencies", "statuses", "periods", "columns"],
    components: {
        ClipLoader,
        Column_Modal,
    },
    data() {
        return {
            selectedStatus: [],
            agency: null,
            period: null,
            loading: false,
            items: [],
            filterItems: [],
            searchRequest: "",
            descending: false,
            lastSort: "sales_period",
            showModalColumns: false,
            selected_col: null,
            current_columns: [],
            filter_columns: [],
        };
    },

    mounted() {
        this.current_columns = JSON.parse(JSON.stringify(this.columns));

        this.fetchData();
    },

    methods: {
        setValue(e) {
            const name = e.target.name;
            const value = e.target.value;

            this[name] = value;

            this.fetchData();
        },
        formatDatePeriod(date) {
            const options = { year: "numeric", month: "long" };
            const _date = new Date(date);

            return _date.toLocaleDateString("en-GB", options);
        },
        checkboxValue(e) {
            if (e.target.checked) {
                this.selectedStatus.push(e.target.value);
                if (e.target.value == 2) {
                    this.selectedStatus.push("3");
                    this.$refs.filter_overdue[0].checked = true;
                }
            } else {
                this.selectedStatus = this.selectedStatus.filter(
                    (i) => i != e.target.value
                );
            }

            this.fetchData();
        },

        fetchData() {
            this.loading = true;

            axios
                .post("/master-invoices/getList", {
                    status: this.selectedStatus,
                    period: this.period,
                    agency: this.agency,
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.length) {
                        this.items = this.reformatDataByColumns(res.data);
                    } else {
                        this.items = [];
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
        search() {
            if (this.searchRequest.length >= 3) {
                this.filterItems = this.items.filter((item) =>
                    item.agency.name
                        .toLowerCase()
                        .includes(this.searchRequest.toLowerCase())
                );
            }
        },

        sortData(sortBy) {
            let self = this;
            if (self.lastSort !== sortBy) self.descending = false;
            self.lastSort = sortBy;
            switch (sortBy) {
                case "agency":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "agency",
                            self.descending,
                            (a) => a.toUpperCase(),
                            "name"
                        )
                    );
                    break;
                case "invoice_number":
                    self.items = self.items.sort(
                        sortArray.sortText(
                            "invoice_number",
                            self.descending,
                            "id"
                        )
                    );
                    break;
                case "sales_period":
                    self.items = self.items.sort(
                        sortArray.sortDate("sales_period", self.descending)
                    );
                    break;
                case "due_date":
                    self.items = self.items.sort(
                        sortArray.sortDate("due_date", self.descending)
                    );
                    break;
                case "status":
                    self.items = self.items.sort(
                        sortArray.sortText("status", self.descending, (a) =>
                            a.toUpperCase()
                        )
                    );
                    break;
                case "amount":
                    self.items = self.items.sort(
                        sortArray.sortMoney("amount", self.descending)
                    );
                    break;
                case "invoiced":
                    self.items = self.items.sort(
                        sortArray.sortMoney("invoiced", self.descending)
                    );
                    break;
                case "collected":
                    self.items = self.items.sort(
                        sortArray.sortMoney("collected", self.descending)
                    );
                    break;
            }
            self.descending = !self.descending;
        },

        // MODAL COLUMNS
        reformatDataByColumns(__items = []) {
            try {
                if (__items.length >= 1) {
                    const newFormatData = [];
                    if (this.current_columns.length >= 1) {
                        __items.forEach((item) => {
                            const tempObj = {};
                            this.current_columns
                                .sort((a, b) => a.position - b.position)
                                .forEach((c) => {
                                    if (c.status === "hidden") {
                                        return;
                                    }
                                    tempObj[`${c.slug}`] = item[c.slug];

                                    if (c.slug === "invoice_number") {
                                        tempObj["invoice_number"] = {
                                            name: item["master_invoice"].id,
                                            link: item["master_invoice"].link,
                                        };
                                    }
                                });

                            newFormatData.push(tempObj);
                        });
                        return newFormatData;
                    }
                }

                return [];
            } catch (err) {
                console.error("reformatDataByColumns error", err);
            }
        },
        openColumnsModal() {
            this.showModalColumns = true;
            document.querySelector("html").style = "overflow-y: hidden";
            document.querySelector("body").style =
                "overflow-y: hidden; margin-right: 16px";
        },
        async closeModal(items = []) {
            await axios
                .post("/master-invoices/updateColumns", {
                    columns: items,
                })
                .then(() => {
                    this.showModalColumns = false;
                    this.current_columns.length = 0;
                    this.current_columns = JSON.parse(JSON.stringify(items));
                    document.querySelector("html").style = "";
                    document.querySelector("body").style = "";
                })
                .catch((err) => {
                    console.error("Axios update columns error", err);
                });
        },
        selectColumn(col) {
            this.selected_col = col;
        },
    },
};
</script>
